import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AARData, EvStationDetails } from '../../aar/aar.types'
import { OperatingDay } from '../../../../shared/types'
import { AAAStore } from 'libs/drrweb-lib/src/lib/store/root-reducer'
import { select, Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { selectShowMemberDiscount } from '../../aar/aar.selectors'

@Component({
  selector: 'app-shop-card-variant',
  templateUrl: './shop-card-variant.component.html',
  styleUrls: ['./shop-card-variant.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShopCardVariantComponent implements OnChanges {
  @Input() destination: AARData
  @Input() borderShadow = true
  @Input() suggested = false
  @Input() rap = false
  @Input() isActive = false

  @Output() onCardClick = new EventEmitter<void>()
  @Output() close = new EventEmitter<void>();

  constructor(private store$: Store<AAAStore>) {}

  showMemberDiscount$: Observable<boolean> = this.store$.pipe(select(selectShowMemberDiscount))

  addressLine1: string
  addressLine2: string
  status: string
  operatingDays: OperatingDay[]
  evStationDetails: EvStationDetails

  ngOnChanges(): void {
    this.addressLine1 = this.destination.address.addressLine
    this.addressLine2 = `${this.destination.address.cityName}, ${this.destination.address.stateProv.code}, ${this.destination.address.postalCode}`
    this.status = this.destination.priority ? $localize`Available Now` : null
    this.operatingDays = this.destination.operatingDays
    this.evStationDetails = this.destination.evStationDetails
  }

  handleCardClick() {
    this.onCardClick.emit()
  }

  onClose() {
    this.close.emit()
  }

}
